
export default function WhyChoose() {
  const benefits = [
    {
      image: 'https://readdy.ai/api/search-image?query=Strategic%20business%20intelligence%20dashboard%20with%20brain%20and%20neural%20network%20visualization%2C%20modern%20AI%20analytics%20interface%20showing%20data%20insights%20and%20decision-making%20tools%2C%20professional%20blue%20and%20purple%20gradient%20design%2C%20clean%20corporate%20aesthetic%20with%20charts%20and%20graphs&width=400&height=240&seq=strategic-intelligence-v2&orientation=landscape',
      title: 'Inteligência Estratégica',
      description: 'Transforme dados em decisões inteligentes.',
      gradient: 'from-blue-500 to-indigo-600'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Secure%20database%20protection%20concept%20with%20shield%20lock%20and%20encrypted%20data%20visualization%2C%20cybersecurity%20dashboard%20with%20green%20and%20blue%20color%20scheme%2C%20professional%20data%20security%20interface%20with%20verification%20checkmarks%20and%20safety%20indicators&width=400&height=240&seq=reliable-data-v2&orientation=landscape',
      title: 'Dados Confiáveis',
      description: 'Informações verificadas e segmentadas com alta precisão para máxima confiabilidade.',
      gradient: 'from-green-500 to-emerald-600'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Professional%20support%20team%20of%20specialists%20in%20modern%20office%20environment%2C%20collaborative%20workspace%20with%20legal%20experts%20and%20data%20analysts%20working%20together%2C%20teamwork%20concept%20with%20blue%20corporate%20colors%20and%20professional%20atmosphere&width=400&height=240&seq=specialized-support-v2&orientation=landscape',
      title: 'Suporte Especializado',
      description: 'Equipe de especialistas dedicada para garantir o sucesso dos seus projetos.',
      gradient: 'from-purple-500 to-violet-600'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Time%20efficiency%20and%20automation%20concept%20with%20clock%20and%20productivity%20symbols%2C%20business%20optimization%20visualization%20with%20orange%20and%20blue%20color%20scheme%2C%20modern%20efficiency%20dashboard%20showing%20time%20savings%20and%20workflow%20automation&width=400&height=240&seq=time-economy-v2&orientation=landscape',
      title: 'Economia de Tempo',
      description: 'Automação que reduz drasticamente o tempo gasto em análises manuais.',
      gradient: 'from-orange-500 to-amber-600'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Cost%20reduction%20and%20financial%20optimization%20dashboard%20with%20money%20savings%20visualization%2C%20business%20efficiency%20charts%20and%20ROI%20improvement%20graphs%2C%20professional%20red%20and%20blue%20color%20scheme%20with%20financial%20metrics%20and%20cost%20analysis&width=400&height=240&seq=cost-reduction-v2&orientation=landscape',
      title: 'Redução de Custos',
      description: 'Otimização de processos que resulta em significativa redução de custos operacionais.',
      gradient: 'from-red-500 to-rose-600'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Python%20automation%20robots%20and%20code%20development%20workspace%20with%20multiple%20screens%20showing%20Python%20scripts%2C%20robotic%20process%20automation%20%28RPA%29%20bots%20working%20with%20data%2C%20modern%20programming%20environment%20with%20Python%20logos%20and%20automated%20workflows%2C%20professional%20blue%20and%20dark%20color%20scheme%2C%20high-tech%20coding%20atmosphere%20with%20robots%20and%20automation%20symbols&width=400&height=240&seq=python-automation-robots-v2&orientation=landscape',
      title: 'Soluções Personalizadas',
      description: 'Automação e análise de dados sob medida para cada cliente.',
      gradient: 'from-cyan-500 to-blue-600'
    }
  ];

  const features = [
    {
      title: "Automação Inteligente",
      description: "Sistemas automatizados que coletam e processam dados de forma eficiente, reduzindo tempo e custos operacionais.",
      icon: "ri-robot-line",
      gradient: "from-blue-600 to-cyan-600",
      image: "https://readdy.ai/api/search-image?query=Advanced%20robotic%20automation%20system%20processing%20legal%20documents%20and%20financial%20data%2C%20modern%20AI%20technology%20with%20blue%20holographic%20interfaces%2C%20sophisticated%20data%20processing%20environment%20with%20automated%20workflows%2C%20clean%20professional%20design&width=400&height=240&seq=automation-feature-v2&orientation=landscape"
    },
    {
      title: "Dados Precisos",
      description: "Informações confiáveis e atualizadas sobre precatórios e RPV, garantindo decisões baseadas em dados sólidos.",
      icon: "ri-database-2-line",
      gradient: "from-indigo-600 to-purple-600",
      image: "https://readdy.ai/api/search-image?query=Precise%20data%20visualization%20dashboard%20showing%20accurate%20financial%20and%20legal%20information%2C%20modern%20analytics%20interface%20with%20charts%20and%20metrics%2C%20professional%20blue%20color%20scheme%2C%20high-quality%20data%20presentation%20with%20accuracy%20indicators&width=400&height=240&seq=data-precision-v2&orientation=landscape"
    },
    {
      title: "Inteligência Estratégica",
      description: "Transforme dados em decisões inteligentes.",
      icon: "ri-lightbulb-line",
      gradient: "from-purple-600 to-pink-600",
      image: "https://readdy.ai/api/search-image?query=Strategic%20business%20intelligence%20visualization%20with%20predictive%20analytics%20and%20decision-making%20insights%2C%20modern%20dashboard%20with%20AI-powered%20recommendations%20and%20strategic%20planning%20tools%2C%20professional%20corporate%20environment%20with%20data-driven%20solutions&width=400&height=240&seq=strategic-intelligence-feature-v2&orientation=landscape"
    },
    {
      title: "Soluções Personalizadas",
      description: "Automação e análise de dados sob medida para cada cliente.",
      icon: "ri-settings-3-line",
      gradient: "from-cyan-600 to-blue-600",
      image: "https://readdy.ai/api/search-image?query=Custom%20software%20development%20workspace%20with%20tailored%20automation%20solutions%2C%20personalized%20business%20applications%20on%20multiple%20screens%2C%20modern%20tech%20environment%20with%20bespoke%20data%20analysis%20tools%20and%20custom%20dashboards%2C%20professional%20blue%20corporate%20design&width=400&height=240&seq=custom-solutions-feature-v2&orientation=landscape"
    }
  ];

  return (
    <>
      {/* Linha separadora */}
      <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
      
      <section id="diferenciais" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-20">
            <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <i className="ri-star-line"></i>
              Diferenciais DataPrec
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6">
              Por que escolher a DataPrec?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Combinamos dados, inteligência e experiência para entregar resultados consistentes e escaláveis
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
            {benefits.map((benefit, index) => (
              <div key={index} className="group relative">
                <div className="bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden transform hover:-translate-y-2">
                  <div className="relative h-48 overflow-hidden">
                    <img 
                      src={benefit.image}
                      alt={benefit.title}
                      className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className={`absolute inset-0 bg-gradient-to-t ${benefit.gradient} opacity-20 group-hover:opacity-30 transition-opacity duration-300`}></div>
                  </div>
                  
                  <div className="p-8">
                    <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-blue-700 transition-colors">
                      {benefit.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Linha separadora antes do propósito */}
          <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent mb-16"></div>

          <div className="relative">
            <div className="bg-gradient-to-r from-blue-900 via-indigo-900 to-blue-800 rounded-3xl p-12 text-center text-white relative overflow-hidden">
              <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg width=&quot;60&quot; height=&quot;60&quot; viewBox=&quot;0 0 60 60&quot; xmlns=&quot;http://www.w3.org/2000/svg&quot;%3E%3Cg fill=&quot;none&quot; fillRule=&quot;evenodd&quot;%3E%3Cg fill=&quot;%23ffffff&quot; fillOpacity=&quot;0.05&quot;%3E%3Ccircle cx=&quot;30&quot; cy=&quot;30&quot; r=&quot;2&quot;/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')] opacity-30"></div>
              
              <div className="relative z-10">
                <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium mb-6">
                  <i className="ri-lightbulb-line text-yellow-300"></i>
                  Nosso Propósito
                </div>
                
                <h3 className="text-3xl font-bold mb-6">Transformando Dados em Oportunidades</h3>
                <p className="text-xl text-blue-100 max-w-4xl mx-auto leading-relaxed mb-8">
                  Democratizamos o acesso à informação sobre precatórios, fornecendo inteligência 
                  que impulsiona resultados e fortalece decisões estratégicas no mercado jurídico brasileiro.
                </p>
                
                <div className="flex flex-wrap justify-center gap-4">
                  <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
                    <span className="text-sm font-medium">🎯 Foco em Resultados</span>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
                    <span className="text-sm font-medium">🚀 Inovação Constante</span>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
                    <span className="text-sm font-medium">🤝 Parceria Estratégica</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
